import React from "react";

const shapes = {
    round: "rounded-[12px]",
    circle: "rounded-[50%]",
} as const;

const variants = {
    outline: {
        "day_text_&_icon_text_01_(inverse)_0":
            "border-[#ffffff] border border-solid text-[#ffffff]",
    },
    fill: {
        night_base_clear: "bg-[#ffffff28]",
        day_base_primary: "bg-[#394456] text-[#ffffff]",
        day_base_clear: "bg-[#0000000a]",
        day_base_secondary: "bg-[#E7E7E7]",
    },
} as const;

const sizes = {
    lg: "h-[56px] px-[34px] text-[15px]",
    xs: "h-[34px] px-2",
    sm: "h-[44px] pl-[18px] pr-2 text-[15px]",
    md: "h-[56px]",
} as const;

type ButtonProps = Omit<
    React.DetailedHTMLProps<
        React.ButtonHTMLAttributes<HTMLButtonElement>,
        HTMLButtonElement
    >,
    "onClick"
> & {
    className?: string;
    leftIcon?: React.ReactNode;
    rightIcon?: React.ReactNode;
    onClick?: () => void;
    shape?: keyof typeof shapes;
    variant?: keyof typeof variants | null;
    size?: keyof typeof sizes;
    color?: string;
};

const Button: React.FC<React.PropsWithChildren<ButtonProps>> = ({
                                                                    children,
                                                                    className = "",
                                                                    leftIcon,
                                                                    rightIcon,
                                                                    shape,
                                                                    variant = "fill",
                                                                    size = "md",
                                                                    color = "day_base_clear",
                                                                    ...restProps
                                                                }) => {
    return (
        <button
            className={`${className} flex flex-row items-center justify-center text-center cursor-pointer whitespace-nowrap ${
                shape ? shapes[shape] : ""
            } ${size ? sizes[size] : ""} ${
                variant
                    ? variants[variant]?.[
                        color as keyof (typeof variants)[typeof variant]
                        ]
                    : ""
            }`}
            {...restProps}
        >
            {!!leftIcon && leftIcon}
            {children}
            {!!rightIcon && rightIcon}
        </button>
    );
};

export {Button};
